import React, { useState, useEffect } from 'react';
import { Modal } from 'antd';

import { MySubtitleH4 } from '../../styled/publicTag';
import { message } from 'antd';

import {  ExclamationCircleOutlined, CloseCircleOutlined, CheckCircleFilled } from '@ant-design/icons';
import { getStopItem, deleteStopItem } from '../../services/api';

import ModalContainer from './ModalContainer'

import Title from '../../components/Custom/Title';
import Wrapper from '../../components/Custom/Wrapper';
import CustomTable from '../../components/antdCustom/CustomTable';
import CustomModal from '../../components/antdCustom/CustomModal';

import {
  IconTrash,
  IconPen
} from '../../components/Icon'


message.config({
  duration: 1.5
})

const StopProject = () => {

  const innerWidth = window.innerWidth;

  const [s_tableData, set_s_tableData] = useState([]);
  const [s_showModal, set_s_showModal] = useState(false);  // 是否開啟 dialog
  const [s_StopProjectData, set_s_StopProjectData] = useState({});     // 要編輯的模具資料
  const [s_searchValue, set_s_searchValue] = useState('');    // 要搜尋的文字

  const [pageInfo, setPageInfo] = useState({
    currentPage: 0,
    pageItemNumber: 10,
    totalItems: 0,
    pageSize: 10
  });

  // 新增停工項目資料
  const createStopProject = () => {
    set_s_showModal(true);
  }

  // 搜尋停工項目資料
  const onSearch = (value, event) => {
    const call_getStopItem = async (value) => {
      
      if(value === '') return;
      
      const res = await getStopItem({'item':value});
      
      if(res.status) {
        set_s_tableData(res.data);
        message.success(res.msg);
      } else {
        message.error(res.msg);
      }

    }
    call_getStopItem(value);
  }

  // 編輯停工項目資料
  const editStopProject = rowData => {
    set_s_showModal(true);
    set_s_StopProjectData(rowData);
  }

   // 刪除停工項目資料
   const removeStopProject = rowData => {
    Modal.confirm({
      title: '停工項目資料刪除確認',
      icon: <ExclamationCircleOutlined style={{color: 'red'}} />,
      content: '請先確認要刪除的停工項目資料無誤，再進行刪除',
      okText: '確定',
      onOk: async () => {
        const res = await deleteStopItem(rowData);
        res.status ? message.success(res.msg) : message.error(res.msg);
        //刪除後要更新資料
        call_getAllStopProject();
      },
      cancelText: '取消',
    });
  }

  // 取得所有停工項目資料
  const call_getAllStopProject = async () => {
    try {
      const res = s_searchValue === '' ? await getStopItem() : await getStopItem({'item':s_searchValue});
      
      if(res.data) {
        console.log('全部停工資料 = ', res.data);
        const tmpData = res.data.map((item, index) => {
          return {
            ...item,
            key: index
          }
        });
        set_s_tableData(tmpData)
      }
      
    } catch (e) {
      console.log('---------- api getAllStaffPerm error ----------');
      console.log(e)
    }
  }
  
  const tableColumns = [
    {
      title: '項目ID',
      dataIndex: 'item',
      key: 'item',
      align: 'center',
      // width: innerWidth <= 1440 ? `${200}px` : `${300}px`
    },
    {
      title: '項目名稱',
      dataIndex: 'itemNM',
      key: 'itemNM',
      align: 'center',
      // width: innerWidth <= 1440 ? `${200}px` : `${250}px`
    },
    {
      title: '註記',
      dataIndex: 'note',
      key: 'note',
      align: 'center',
      // width: innerWidth <= 1440 ? `${100}px` : `${150}px`
    },
    {
      title: '操作',
      dataIndex: 'render',
      key: 'render',
      align: 'center',
      width: innerWidth <= 1440 ? `${50}px` : `${50}px`,
      render: (text, rowData, index) => (
        <div style={{display: 'flex',justifyContent: 'center'}}>
          <div style={{display: 'flex'}}>
            <IconPen className='icon' onClick={() => editStopProject(rowData)} />
            <IconTrash className='icon' onClick={() => removeStopProject(rowData)} />
          </div>
        </div>
      )
    },
  ]

  // 取得所有停工項目資料
  useEffect(() => { 
    call_getAllStopProject();
  }, []);

  const handleChange = async value => {
    console.log(value)
    set_s_searchValue(value)
    if(value === '') {
      try {
        const res = await getStopItem();
        
        if(res.data) {
          console.log('全部停工資料 = ', res.data);
          const tmpData = res.data.map((item, index) => {
            return {
              ...item,
              key: index
            }
          });
          set_s_tableData(tmpData)
        }
        
      } catch (e) {
        console.log('---------- api getAllStaffPerm error ----------');
        console.log(e)
      }
    }
  }
  
  return (
    <>
      <Title 
        title='停工項目管理'
        placeholder='請輸入欲查詢停工項目資料'
        onSearch={onSearch}
        handleChange={handleChange}
        handleClick={createStopProject}
      />
      <CustomTable 
        scroll={{x: 'max-content', y: window.innerHeight - 60 - 45 - 220 }}
        columns={tableColumns}
        dataSource={s_tableData.map((item, index) => {
          return {
            key: index,
            ...item
          }
        })}
        pagination={{
          defaultCurrent: 1,
          total: pageInfo.totalItems,
          // current: abcBoardConfig.page,
          showSizeChanger: true,
          pageSize: pageInfo.pageSize,
          pageSizeOptions: ["10", "20", "30"],
          onChange: (current, size) => {
            setPageInfo({
              ...pageInfo,
              pageSize: size
            })
          },
          showTotal: (total, range) => (
            <MySubtitleH4>
              共 {total} 項 ， 正在顯示第{range[0]}到{range[1]}項
            </MySubtitleH4>
          ),
        }}
      />
      {s_showModal ? (
        <CustomModal 
          width='30%' 
          title={Object.keys(s_StopProjectData).length > 0 ? "修改停工管理資料" : "新建停工管理資料"} 
          visible={s_showModal} 
          maskClosable={false}
          destroyOnClose
          footer={null}
          forceRender
          getContainer={false}
          onCancel={() => set_s_showModal(false)}
          afterClose={() => {
            set_s_StopProjectData({});
            call_getAllStopProject();
          }}
        >
          <ModalContainer set_s_showModal={set_s_showModal} s_StopProjectData={s_StopProjectData} set_s_StopProjectData={set_s_StopProjectData} call_getAllStopProject={call_getAllStopProject} />
        </CustomModal>
      ) : null}
      
    </>
  )
};

export default StopProject;